import { render, staticRenderFns } from "./AdminWebcretarium.vue?vue&type=template&id=673a14ee"
import script from "./AdminWebcretarium.vue?vue&type=script&lang=js"
export * from "./AdminWebcretarium.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports